import { useScreenSize } from '@/hooks/useScreenSize';

interface ShopLocationIconProps {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
    svgProps?: React.SVGProps<SVGSVGElement>;
}

const ShopLocationIcon = ({ color = 'currentColor', width = 21, height = 29, className, svgProps }: ShopLocationIconProps) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 21 29"
            fill="none"
            className={className}
            {...svgProps}
        >
            <path
                d="M-7.64949e-07 11C-7.64949e-07 5.20101 4.70101 0.5 10.5 0.5C16.299 0.499999 21 5.20101 21 11C21 18.5483 10.5018 28.4983 10.5 28.5C10.4982 28.4983 -7.64949e-07 18.5483 -7.64949e-07 11ZM2 11C2 12.4542 2.51634 14.1737 3.43457 16.0342C4.34195 17.8726 5.57307 19.7106 6.83887 21.3652C8.10024 23.0141 9.36648 24.4428 10.3193 25.46C10.3805 25.5253 10.4416 25.5876 10.5 25.6494C10.5584 25.5876 10.6195 25.5253 10.6807 25.46C11.6335 24.4428 12.8998 23.0141 14.1611 21.3652C15.4269 19.7106 16.6581 17.8726 17.5654 16.0342C18.4837 14.1737 19 12.4542 19 11C19 6.30558 15.1944 2.5 10.5 2.5C5.80558 2.5 2 6.30558 2 11ZM6.125 11C6.125 8.58375 8.08375 6.625 10.5 6.625C12.9162 6.625 14.875 8.58375 14.875 11C14.875 13.4162 12.9162 15.375 10.5 15.375C8.08375 15.375 6.125 13.4162 6.125 11ZM10.5 13.375C11.8117 13.375 12.875 12.3117 12.875 11C12.875 9.68832 11.8117 8.625 10.5 8.625C9.18832 8.625 8.125 9.68832 8.125 11C8.125 12.3117 9.18832 13.375 10.5 13.375Z"
                fill={color}
            />
        </svg>
    );
};

export default ShopLocationIcon;
